import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    signal,
    WritableSignal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { StepperModule } from 'primeng/stepper';

// TODO #CSD-1080 implement new API & CSS of StepperModule once this component is used within the codebase
@Component({
    selector: 'apcam-client-progress-stepper',
    templateUrl: './client-progress-stepper.component.html',
    styleUrl: './client-progress-stepper.component.scss',
    imports: [NgClass, StepperModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientProgressStepperComponent {
    /**
     * Items representing individual steps
     *
     * @default []
     */
    @Input()
    items: WritableSignal<MenuItem[]> = signal([]);

    /**
     * Active index of a stepper
     *
     * @default -1
     */
    @Input()
    activeStep: WritableSignal<number> = signal(-1);

    protected readonly STEPS_LIMIT_FOR_BULLETS = 8;

    /**
     * Styles the progress stepper based on the current active index
     */
    // private computeStepperStyling(activeStep: number): void {
    //     const items = document.querySelectorAll(
    //         '.progress-stepper .p-steps-item'
    //     );
    //     const bullets = document.querySelectorAll(
    //         '.progress-stepper .p-steps-item .p-steps-number'
    //     );

    //     items.forEach((item, idx) => {
    //         item.classList.add('not-completed-step');
    //         if (idx <= activeStep) {
    //             item.classList.remove('not-completed-step');
    //         }
    //     });

    //     bullets.forEach((item, idx) => {
    //         item.classList.remove('completed-step');
    //         if (idx <= activeStep) {
    //             item.classList.add('completed-step');
    //         }
    //     });
    // }
}
